import { BaseDto } from './BaseDto';

export interface Vendor {
  workflowId: number;
  createdDate: Date;
  workflowName: string;
  isActive: boolean;
  isCompleted: boolean;
  updatedBy: string;
  lastUpdated: null;
  requestedBy: string;
  completedDate: null;
  createdBy: string;
  id: string;
  approvalStatus: string;
  workflowStep: string;
  allApprovers: never[];
  declinedReason: string;
  currentApprovers: never[];
  vendorId: string;
  approvalWorkflowId: string;
  comments: never[];
  documents: never[];
  providesMerchandiseOrUtilities: boolean | null;
  vendorNumber: string;
  name: string;
  legalName: string;
  address: string;
  addressLine2: string;
  isInternational: boolean;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  description: string;
  w9Status: string;
  futureBidStatus: string;
  w9StatusReason: string;
  referenceId: string;
  vendorType: string;
  tradeBusinessEngaged: string;
  receivesRentOrRoyaltyIncome: string;
  applicableTaxIdentificationNumber: string;
  socialSecurityNumber: string;
  employerIdentificationNumber: string;
  form1099Applicable: string;
  form1099ApplicableOther: string;
  isIncorporated: string;
  corporationType: string;
  medicalLegalServicesStatus: string;
  payViaACH: boolean | null;
  bankName: string;
  bankRoutingNumber: string;
  bankAccountNumber: string;
  bankAccountType: string;
  bankAccountClass: number;
  digitalCheckEmailAddress: string;
  client: string;
  clientId: string;
  contacts: VendorContact[];
  vendorDepartments: VendorDepartmentAssignment[];
  minorityBusinessEnterprise: boolean | null;
  existingBusinessRelation: boolean | null;
  label: string;
  paymentType: string;
  deliveryMethod: string;
}

export interface VendorContact extends BaseDto<string> {
  additionalContactInfo: string;
  contactType: string;
  emailAddress: string;
  contactName: string;
  extension: string;
  phone: string;
  suffix: string;
  title: string;
  isDeleted: boolean;
}

export interface VendorDepartmentAssignment {
  departmentId: number;
  departmentName: string;
  vendorId: string;
}

export enum vendorAddressAndContactType {
  Purchasing = 1,
  Remittance = 2,
}

export interface UsState {
  name: string;
  abbreviation: string;
}
